export function btn(ctx) {
    return {
        styles: {
            // radius: 999 (pill-shaped button) is a deliberate designer stylistic choice, not a
            // firmware match — firmware's real styles->btn radius is LV_DPI/12 = 13 (a modest
            // rounded rect, lv_theme_hasp.c:362), matched by the schema's own default. Every
            // bundled theme (hasp-light/material-dark/material-light/mono) uses this same 999
            // convention uniformly for buttons, confirming it's this codebase's consistent visual
            // language rather than an isolated per-theme mistake.
            main: { ...ctx.btnStyle, radius: 999, text_font: 32 },
        },
    };
}
